<template>
  <v-layout style="position: absolute; top: 0; left: 0px; right: 0; bottom: 0;">
    <v-col style="height: 100%; overflow-y: auto; max-width: 400px; min-width: 315px;">
      <v-treeview
        v-if="folderTree.length"
        dense
        hoverable
        open-all
        :items="folderTree"
        item-key="id"
        item-text="text"
        activatable
        :active.sync="active"
        @update:active="checkOpenContext"
        style="width: 300px;"
      >
        <template v-slot:label="{ item }">
          <explorer-drop-helper :item="item" :workspace="currentWorkspace"></explorer-drop-helper>
          <div draggable="true" @dragstart.prevent="dragStart(item.id, item.type, $event)">
            <v-icon x-small icon v-if="item.type != 'currentWorkspace'">drag_indicator</v-icon>
            <v-icon v-if="item.type == 'folder'" small>
              {{ open ? 'folder_open' : 'folder' }}
            </v-icon>
            <c-icon
              v-else-if="item.type == 'context'"
              icon="context"
              size="16"
              class="mr-2"
            ></c-icon>
            <template v-if="item.type == 'folder'">
              <v-text-field
                v-if="editFolderName == item.id"
                :ref="item.id"
                @keypress.enter="editFolderName = false"
                @blur="editFolderName = false"
                @click="editFolderName == item.id ? $event.stopPropagation() : null"
                autofocus
                :value="item.text"
                style="display: inline-flex;"
                @input="
                  updateFolderName({
                    folderId: item.id,
                    workspaceId: currentWorkspaceId,
                    text: $event
                  })
                "
              ></v-text-field>
              <span v-else @dblclick.prevent="editFolderName = item.id">{{
                item.text || 'New Folder'
              }}</span>
            </template>
            <template v-else>
              <v-text-field
                v-if="editFolderName == item.id"
                :ref="item.id"
                @keypress.enter="editFolderName = false"
                @blur="editFolderName = false"
                @click="editFolderName == item.id ? $event.stopPropagation() : null"
                autofocus
                :value="item.text"
                style="display: inline-flex;"
                @input="
                  updateContextText({ text: $event, contextId: item.id });
                  item.text = $event;
                "
              ></v-text-field>
              <span v-else class="pr-2">{{ item.text || 'New Context' }}</span>
              <!-- <user-avatar
                    v-for="author in item.authors"
                    :size="14"
                    :avatarUrl="author.avatar"
                    :key="author.id"
                  ></user-avatar> -->
            </template>
          </div>
        </template>
        <template v-slot:append="{ item, open }">
          <new-item-button
            v-if="item.type != 'context'"
            @click.stop.prevent
            class="my-0"
            @createContext="
              $emit('newContext', {
                workspaceId: currentWorkspaceId,
                parentFolderId: item.type != 'currentWorkspace' ? item.id : undefined
              })
            "
            @createFolder="
              createFolder({
                workspaceId: currentWorkspaceId,
                parentFolderId: item.type == 'folder' ? item.id : undefined
              })
            "
          ></new-item-button>
          <v-menu offset-y v-if="item.type != 'currentWorkspace'">
            <template v-slot:activator="{ on }">
              <v-btn icon x-small v-on="on" class="mr-0" @click.stop>
                <v-icon small>more_vert</v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item @click="editFolderName = item.id">
                <v-list-item-title>Rename</v-list-item-title>
              </v-list-item>
              <v-list-item
                v-if="item.type == 'context'"
                @click="settings = { item: item, type: 'context', show: true }"
              >
                <v-list-item-title>Edit Settings</v-list-item-title>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item @click="deleteHandler(space, item)">
                <v-list-item-title>Delete</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
      </v-treeview>
    </v-col>
    <v-flex
      grow
      class="px-4"
      :style="
        `overflow-y: auto;
              overflow-x: hidden;
              height: 100%;`
      "
    >
      <v-layout>
        <!-- <div class="pt-2 pl-2">
          <v-btn icon><v-icon color="primary">add_circle</v-icon></v-btn>
        </div> -->
        <!-- <v-breadcrumbs
          :items="[{ text: 'Folder A', exact: true }, { text: 'Folder B', exact: true }]"
        >
          <template v-slot:item="props">
            <v-breadcrumbs-item href="#" @click.native.stop="">
              {{ props.item.text.toUpperCase() }}
            </v-breadcrumbs-item>
          </template>
        </v-breadcrumbs> -->
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-layout>
      <v-data-table
        v-if="currentWorkspaceId"
        v-on:click:row="c.log($event)"
        class="transparent"
        :search="search"
        must-sort
        sort-by="lastOpenedByUser"
        sort-desc
        :headers="[
          { text: 'Type', value: 'type' },
          { text: 'Name', value: 'text' },
          { text: 'Permission', value: 'permissions' },
          { text: 'Authors' },
          { text: 'Last Opened', value: 'lastOpenedByUser' },
          { text: 'Created On', value: 'createdOn' },
          { text: ' ' }
        ]"
        :items="activeContexts"
      >
        <template v-slot:body="{ items }">
          <tbody>
            <tr
              v-for="item in items"
              :key="item.id"
              :class="{ 'grey lighten-2': selectedItem == item.id }"
              @dblclick="openContext(item.id)"
              @click="selectedItem = item.id"
              draggable="true"
              @dragstart.prevent="dragListItemStart(item.id, item.type, $event)"
              style="user-select: none;"
            >
              <td width="80">
                <v-icon v-if="item.type == 'folder'" size="16">folder</v-icon>
                <c-icon v-else-if="item.type == 'context'" icon="context" size="16"></c-icon>
              </td>
              <td>{{ item.text }}</td>
              <td>
                <v-icon v-if="item.userPermission == 'editing'" size="16">edit</v-icon>
                <c-icon v-else-if="item.userPermission == 'viewing'" icon="context" size="16"
                  >visibility</c-icon
                >
              </td>
              <td>
                <user-avatar
                  v-for="author in item.authors"
                  :avatarUrl="author.avatar"
                  :key="author.id"
                  size="24"
                ></user-avatar>
              </td>
              <td>{{ item.lastOpenedByUser | formatDate }}</td>
              <td>{{ item.createdOn | formatDate }}</td>
              <td width="180">
                <v-btn text v-if="selectedItem == item.id" @click="openContext(item.id)">
                  OPEN
                </v-btn>
                <v-btn
                  icon
                  v-if="selectedItem == item.id"
                  @click.stop="setModal({ item: item, type: 'context', show: true })"
                  ><v-icon>settings</v-icon></v-btn
                >
                 <v-dialog v-if="selectedItem == item.id" v-model="confirmDeleteModal" width="400">
                  <template v-slot:activator="{ on }">
                    <v-btn icon v-on="on"><v-icon>delete</v-icon></v-btn>
                  </template>
                  <v-card>
                    <v-card-title>
                      Delete Context?
                    </v-card-title>
                    <v-card-text>
                      Are you super sure? There ain't no coming back from this.
                    </v-card-text>
                    <v-card-actions>
                      <v-btn color="warning" @click="handleDeleteContext(item.id)">Yes, Delete Context</v-btn>
                      <v-btn @click="confirmDeleteModal = false">Cancel</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import ExplorerDropHelper from '@/components/Explorer/ExplorerDropHelper';
import NewItemButton from '@/components/Explorer//NewItemButton';
import UserAvatar from '@/components/UserAvatar';
export default {
  components: { NewItemButton, ExplorerDropHelper, UserAvatar },
  props: ['space'],
  data() {
    return {
      c: console,
      search: null,
      showTree: false,
      open: [],
      active: [],
      selectedItem: null,
      editFolderName: false,
      tree: [],
      confirmDeleteModal: false,
      settings: {
        item: null,
        type: null,
        show: false
      }
    };
  },
  watch: {
    // $route(to, from) {
    //   // react to route changes...
    // },
    active(to, from) {
      if (to != from && this.selectedItem) {
        this.selectedItem = null;
      }
    }
  },
  mounted() {
    this.open = [this.currentWorkspaceId];
    // this.selectedContexts = this.folderTree
    //   ? this.folderTree
    //   : [];
  },
  computed: {
    ...mapGetters('workspaces', ['currentWorkspace', 'workspaceContexts', 'userPermissionIds']),
    ...mapGetters('userWorkspaceLite', ['currentUserWorkspaceLite']),
    ...mapGetters('components/dragdrop', ['dragging']),
    ...mapState('workspaces', ['currentWorkspaceId']),
    activeContexts() {
      let contexts = [];
      if (this.active.length && this.active[0] != this.currentWorkspaceId) {
        const folder = this.currentWorkspace.folders[this.active[0]];
        //  hydrate folder contexts if we have them in our userWorkspaceLite doc / permissions
        if (folder && folder.contexts) {
          folder.contexts.forEach(c => {
            const foundContext = this.workspaceContexts.find(wc => wc.id == c);
            if (foundContext) {
              contexts.push(foundContext);
            }
          });
        }
      } else {
        //  otherwise dive all
        contexts = this.workspaceContexts;
      }
      return contexts.map(c => {
        const date = typeof c.createdOn.toDate == 'function' ? c.createdOn.toDate() : c.createdOn;
        return {
          ...c,
          sortCreatedOn: date
        };
      });
    },
    folderTree() {
      const { currentWorkspace, userPermissionIds, currentUserWorkspaceLite } = this;
      if (
        !currentWorkspace ||
        !currentUserWorkspaceLite ||
        !currentUserWorkspaceLite.documentData
      ) {
        return [];
      }
      let folderTree = [];

      const folders = Object.values(currentWorkspace.folders);
      folderTree = [
        {
          id: currentWorkspace.id,
          type: 'currentWorkspace',
          text: currentWorkspace.profile.name,
          permissions: 'editing',
          children: populateChildren(
            folders,
            currentWorkspace,
            currentUserWorkspaceLite,
            currentWorkspace.id,
            userPermissionIds
          )
        }
      ];

      return folderTree;

      function populateChildren(
        folders,
        workspace,
        currentUserWorkspaceLite,
        id,
        userPermissionIds
      ) {
        const returnObj = [];
        //get all the children
        const filteredChildren = folders.filter(folder => folder.parent === id);
        filteredChildren.forEach(childFolder => {
          //determine the users permissions regarding that folder by checking for userId, groupsId, or workspaceId
          let permissions = 'none';
          if (userPermissionIds.includes(childFolder.permissions.owner)) {
            permissions = 'owner';
          } else if (userPermissionIds.some(id => childFolder.permissions.editing.includes(id))) {
            permissions = 'editing';
          } else if (userPermissionIds.some(id => childFolder.permissions.viewing.includes(id))) {
            permissions = 'viewing';
          }

          const children = populateChildren(
            folders,
            workspace,
            currentUserWorkspaceLite,
            childFolder.id,
            userPermissionIds
          );

          if (children.length !== 0 || permissions !== 'none') {
            //create a return object if it has children then populate the children
            returnObj.push({
              id: childFolder.id,
              type: 'folder',
              text: childFolder.text,
              contexts: childFolder.contexts,
              permissions: permissions,
              // children: hasChildren ? populateChildren(folders, childFolder.id, userId) : {};
              children: children
            });
          }
        });

        // if (workspace.id === id) {
        //   workspace.contexts.forEach(contextId => {
        //     const contextLite = currentUserWorkspaceLite.documentData[contextId];
        //     if (contextLite) {
        //       let contextLiteCopy = {
        //         ...contextLite,
        //         type: 'context',
        //         permissions: contextLite.userPermission
        //       };
        //       //contextLiteCopy.type = 'context';
        //       delete contextLiteCopy.workspace;
        //       //contextLiteCopy.permissions = contextLiteCopy.userPermission;
        //       delete contextLiteCopy.userPermission;
        //       returnObj.push(contextLiteCopy);
        //     }
        //   });
        // } else {
        //   const folderOfInterest = folders.find(folder => folder.id === id);
        //   folderOfInterest.contexts.forEach(contextId => {
        //     const contextLite = currentUserWorkspaceLite.documentData[contextId];
        //     if (contextLite) {
        //       let contextLiteCopy = { ...contextLite };
        //       contextLiteCopy.type = 'context';
        //       delete contextLiteCopy.workspace;
        //       contextLiteCopy.permissions = contextLiteCopy.userPermission;
        //       delete contextLiteCopy.userPermission;
        //       returnObj.push(contextLiteCopy);
        //     }
        //   });
        // }
        return returnObj;
      }
    }
  },
  methods: {
    ...mapMutations('components/settingsModal', ['setModal']),
    ...mapActions('workspaces', [
      'updateWorkSpaceName',
      'addFolder',
      'updateFolderName',
      'deleteFolder'
    ]),
    ...mapActions('context', ['deleteContext', 'updateContextText']),
    ...mapMutations('components/dragdrop', ['setDragPosition', 'updateDraggedData']),
    async createFolder(options) {
      const id = await this.addFolder(options);
      if (options.parentFolderId && !this.open.includes(options.parentFolderId)) {
        this.open.push(options.parentFolderId);
      }
      this.$nextTick(() => {
        console.log(id);
        this.editFolderName = id;
      });
    },
    deleteHandler(space, item) {
      if (item.type === 'folder') {
        this.deleteFolder({ folderId: item.id, workspaceId: this.currentWorkspaceId });
      } else if (item.type === 'context') {
        this.deleteContext({ contextId: item.id });
      }
    },
    handleDeleteContext(contextId) {
      this.deleteContext({ contextId });
      this.selectedItem = null;
      this.confirmDeleteModal = false;
    },
    checkOpenContext(active) {
      if (active[0] && this.workspaceContexts.find(c => c.id == active[0])) {
        //  we clicked on a context, lets open it
        this.$router.push({ name: 'context', params: { contextId: active[0] } });
      }
    },
    openContext(id) {
      this.$router.push({ name: 'context', params: { contextId: id } });
    },
    dragStart(id, type, event) {
      // get the element and shift positions for dragHelper
      console.log(event);
      const element = event.target.parentElement.parentElement.parentElement.parentElement;
      const html = element.outerHTML;
      const ids = [id];
      //  Build the html drag element
      // ids.forEach(i => {
      //   html += this.$refs[i][0].$el.innerHTML;
      // });
      //const element = this.$refs[id][0].$el.innerHTML;
      // update drag data
      const dragObject = {
        element,
        shift: {
          x: event.clientX - element.getBoundingClientRect().left,
          y: event.clientY - element.getBoundingClientRect().top
        },
        html,
        ids,
        types: [type],
        parent: { type: 'workspace', id: this.currentWorkspaceId }
      };
      //  first set initial drag position
      const { x, y } = event;
      this.setDragPosition({ x, y });

      //  now set drag content
      this.updateDraggedData(dragObject);

      // //  setup move listeners
      // document.addEventListener('mousemove', this.updateDragPos);
      // document.addEventListener('mouseup', this.handleDragStop);
    },
    dragListItemStart(id, type, event) {
      // get the element and shift positions for dragHelper
      console.log(event);
      const element = event.target;
      const iconElement = element.children[0].firstChild.cloneNode(true);
      iconElement.classList.add('mr-2');
      const titleElement = element.children[1].firstChild.cloneNode(true);
      const wrapperElement = document.createElement('div');
      wrapperElement.classList.add('pa-3');
      wrapperElement.style.maxWidth = '400px';
      wrapperElement.appendChild(iconElement);
      wrapperElement.appendChild(titleElement);

      const html = wrapperElement.outerHTML;
      const el = { offsetWidth: '400', offsetHeight: element.offsetHeight };
      console.log(html);
      const ids = [id];
      //  Build the html drag element
      // ids.forEach(i => {
      //   html += this.$refs[i][0].$el.innerHTML;
      // });
      //const element = this.$refs[id][0].$el.innerHTML;
      // update drag data
      const dragObject = {
        element: el,
        shift: {
          x: event.clientX - element.getBoundingClientRect().left,
          y: event.clientY - element.getBoundingClientRect().top
        },
        html,
        ids,
        types: [type],
        parent: { type: 'workspace', id: this.currentWorkspaceId }
      };
      //  first set initial drag position
      const { x, y } = event;
      this.setDragPosition({ x, y });

      //  now set drag content
      this.updateDraggedData(dragObject);

      // //  setup move listeners
      // document.addEventListener('mousemove', this.updateDragPos);
      // document.addEventListener('mouseup', this.handleDragStop);
    }
  }
};
</script>

<style>
.workspace-panel .v-expansion-panel-content__wrap {
  width: 100%;
  padding-right: 0px;
}
</style>
